/* eslint-disable max-len */
const config = {
  localhost: {
    ENV: 'dev',
    NOT_PROD: true,
    NEPTUNE: true,
    ANALYTICS_URL: '/analytics',
    ANALYTICS_V2_URL: '/analytics',
    CHEM_ADMIN_URL: '/chemical-admin',
    CHEMICALS_URL: 'https://dev.riskandsafety.com/chemicals',
    BSAS_URL: 'http://localhost:8095/bsas',
    NFPA_URL: 'http://localhost:8075/nfpa',
    CLI_URL: 'http://localhost:4200',
    GRAPH_URL: 'http://localhost:3001',
    DRIVE_URL: 'https://dev.riskandsafety.com/drive/api',
    HELP_URL: '/help',
    HELP_SUBMIT_TICKET_URL:
      'https://support.dev.riskandsafety.com/rss_support?id=rss_help_id&sys_id=84817e251bb5e89007d49608bd4bcb9f',
    HELP_SUBMIT_TICKET_URL_EXTERNAL:
      'https://support.dev.riskandsafety.com/rss_support?id=rss_help&sys_id=2d38e9a51b8b1c106a9399f4bd4bcb52',
    LIBRARY_URL: 'http://localhost:3021',
    LD_CLIENT_ID: '6463ffb9f8cf2311effb5461',
    MAQ_URL: 'https://dev.riskandsafety.com/maq',
    PROFILE_URL: '/profile',
    PRINTABLE_URL: 'http://localhost:3023',
    BRANDING_URL: 'http://localhost:3010/api',
    BRANDING_GRAPH_URL: 'http://localhost:3010/graphql',
    RELATIONSHIP_GRAPH_URL: 'https://dev.riskandsafety.com/relationship-v2/graphql',
    RSS_WC_URL: 'https://dev.riskandsafety.com/web-components',
    TRAINING_API: 'https://dev.riskandsafety.com/learning',
    COGNITO_AUTH: {
      region: 'us-west-2',
      userPoolId: 'us-west-2_HG4jXkc8G',
      userPoolWebClientId: '4iq22397h9cfl1l3iiejbcfusn',
      authenticationFlowType: 'USER_SRP_AUTH',
      cookieStorage: {
        domain: document.domain,
        path: '/',
        expires: null,
        secure: false,
      },
      oauth: {
        domain: 'auth.dev.riskandsafety.com',
        scope: ['openid', 'aws.cognito.signin.user.admin'],
        redirectSignIn: `${document.location.protocol}//${document.location.host}`,
        redirectSignOut: `${document.location.protocol}//${document.location.host}/public/signout`,
        responseType: 'code',
      },
    },
    COGNITO_INVITATION_AUTH: {
      region: 'us-west-2',
      userPoolId: 'us-west-2_I8jBjHsxJ',
      userPoolWebClientId: '1nq7vgbr6qu5biemisj1srptt',
      authenticationFlowType: 'USER_SRP_AUTH',
      storage: window.sessionStorage,
      oauth: {
        domain: 'invite-dev.auth.us-west-2.amazoncognito.com',
        scope: ['openid'],
        redirectSignIn: `${document.location.protocol}//${document.location.host}/public/invitation`,
        redirectSignOut: `${document.location.protocol}//${document.location.host}/`,
        responseType: 'code',
      },
    },
    MOODLE_CLIENT_ID: '4l6qphclqv9ef1o2fm9g6hinem',
    SPOOF_USER_KEY: 'RSS:SPOOF:USER',
    SELECTED_IDP_KEY: 'RSS:SELECTED:IDP',
    SERVICE_NOW_AUTH_URL:
      'https://ucermdev.service-now.com/login_with_sso.do?glide_sso_id=a4b0cc3bdb48641041e4236ed39619b6',
    ANALYTICS_TRAINING: {
      GROUP: {
        analyticsId: '77f3926b-9dc5-4730-992f-e83a78264358',
        workspaceId: '28dcaa9f-5c1c-4f5a-97bf-a4ffa5fc6e6a',
      },
    },
    ASSESSMENT_ELASTIC_ENABLED: false,
  },
  'hc-test': {
    ENV: 'dev',
    NOT_PROD: true,
    NEPTUNE: true,
    ANALYTICS_URL: '/analytics',
    ANALYTICS_V2_URL: '/analytics',
    CHEM_ADMIN_URL: '/chemical-admin',
    CHEMICALS_URL: '/chemicals',
    BSAS_URL: '/bsas/api',
    CLI_URL: '/cli/api',
    NFPA_URL: '/nfpa/api',
    GRAPH_URL: '/graph/api',
    DRIVE_URL: '/drive/api',
    HELP_URL: '/help',
    HELP_SUBMIT_TICKET_URL:
      'https://support.riskandsafety.com/rss_support?id=rss_help_id&sys_id=84817e251bb5e89007d49608bd4bcb9f&hcapp=true',
    HELP_SUBMIT_TICKET_URL_EXTERNAL:
      'https://support.riskandsafety.com/rss_support?id=rss_help&sys_id=2d38e9a51b8b1c106a9399f4bd4bcb52&hcapp=true',
    LIBRARY_URL: '/library',
    MAQ_URL: '/maq',
    PROFILE_URL: '/profile',
    PRINTABLE_URL: '/printable/api',
    BRANDING_URL: '/branding/api',
    BRANDING_GRAPH_URL: '/branding/graphql',
    RELATIONSHIP_GRAPH_URL: '/relationship-v2/graphql',
    RSS_WC_URL: '/web-components',
    TRAINING_API: '/learning',
    COGNITO_AUTH: {
      region: 'us-west-2',
      userPoolId: 'us-west-2_HG4jXkc8G',
      userPoolWebClientId: '8il5qps36agta2degkr6s1scg',
      authenticationFlowType: 'USER_SRP_AUTH',
      cookieStorage: {
        domain: document.domain,
        path: '/',
        expires: null,
        secure: true,
      },
      oauth: {
        domain: 'auth.dev.riskandsafety.com',
        scope: ['openid', 'aws.cognito.signin.user.admin'],
        redirectSignIn: `${document.location.protocol}//${document.location.host}`,
        redirectSignOut: `${document.location.protocol}//${document.location.host}/public/signout`,
        responseType: 'code',
      },
    },
    COGNITO_INVITATION_AUTH: {
      region: 'us-west-2',
      userPoolId: 'us-us-west-2_I8jBjHsxJ',
      userPoolWebClientId: '7ndfi6tbcbkso2ujg0rn4mrllr',
      authenticationFlowType: 'USER_SRP_AUTH',
      storage: window.sessionStorage,
      oauth: {
        domain: 'invite-dev.auth.us-west-2.amazoncognito.com',
        scope: ['openid'],
        redirectSignIn: `${document.location.protocol}//${document.location.host}/public/invitation`,
        redirectSignOut: `${document.location.protocol}//${document.location.host}/`,
        responseType: 'code',
      },
    },
    MOODLE_CLIENT_ID: '4l6qphclqv9ef1o2fm9g6hinem',
    SPOOF_USER_KEY: 'RSS:SPOOF:USER',
    SELECTED_IDP_KEY: 'RSS:SELECTED:IDP',
    ASSESSMENT_ELASTIC_ENABLED: false,
  },
  dev: {
    ENV: 'dev',
    NOT_PROD: true,
    NEPTUNE: true,
    ANALYTICS_URL: '/analytics',
    ANALYTICS_V2_URL: '/analytics',
    CHEM_ADMIN_URL: '/chemical-admin',
    CHEMICALS_URL: '/chemicals',
    BSAS_URL: '/bsas/api',
    CLI_URL: '/cli/api',
    NFPA_URL: '/nfpa/api',
    GRAPH_URL: '/graph/api',
    DRIVE_URL: '/drive/api',
    HELP_URL: '/help',
    HELP_SUBMIT_TICKET_URL:
      'https://support.dev.riskandsafety.com/rss_support?id=rss_help_id&sys_id=84817e251bb5e89007d49608bd4bcb9f',
    HELP_SUBMIT_TICKET_URL_EXTERNAL:
      'https://support.dev.riskandsafety.com/rss_support?id=rss_help&sys_id=2d38e9a51b8b1c106a9399f4bd4bcb52',
    LIBRARY_URL: '/library',
    LD_CLIENT_ID: '6463ffb9f8cf2311effb5461',
    MAQ_URL: '/maq',
    PROFILE_URL: '/profile',
    PRINTABLE_URL: '/printable/api',
    BRANDING_URL: '/branding/api',
    BRANDING_GRAPH_URL: '/branding/graphql',
    RELATIONSHIP_GRAPH_URL: '/relationship-v2/graphql',
    RSS_WC_URL: '/web-components',
    TRAINING_API: '/learning',
    COGNITO_AUTH: {
      region: 'us-west-2',
      userPoolId: 'us-west-2_HG4jXkc8G',
      userPoolWebClientId: '8il5qps36agta2degkr6s1scg',
      authenticationFlowType: 'USER_SRP_AUTH',
      cookieStorage: {
        domain: document.domain,
        path: '/',
        expires: null,
        secure: true,
      },
      oauth: {
        domain: 'auth.dev.riskandsafety.com',
        scope: ['openid', 'aws.cognito.signin.user.admin'],
        redirectSignIn: `${document.location.protocol}//${document.location.host}`,
        redirectSignOut: `${document.location.protocol}//${document.location.host}/public/signout`,
        responseType: 'code',
      },
    },
    COGNITO_INVITATION_AUTH: {
      region: 'us-west-2',
      userPoolId: 'us-us-west-2_I8jBjHsxJ',
      userPoolWebClientId: '7ndfi6tbcbkso2ujg0rn4mrllr',
      authenticationFlowType: 'USER_SRP_AUTH',
      storage: window.sessionStorage,
      oauth: {
        domain: 'invite-dev.auth.us-west-2.amazoncognito.com',
        scope: ['openid'],
        redirectSignIn: `${document.location.protocol}//${document.location.host}/public/invitation`,
        redirectSignOut: `${document.location.protocol}//${document.location.host}/`,
        responseType: 'code',
      },
    },
    MOODLE_CLIENT_ID: '4l6qphclqv9ef1o2fm9g6hinem',
    SPOOF_USER_KEY: 'RSS:SPOOF:USER',
    SELECTED_IDP_KEY: 'RSS:SELECTED:IDP',
    SERVICE_NOW_AUTH_URL:
      'https://ucermdev.service-now.com/login_with_sso.do?glide_sso_id=a4b0cc3bdb48641041e4236ed39619b6',
    ANALYTICS_TRAINING: {
      GROUP: {
        analyticsId: '77f3926b-9dc5-4730-992f-e83a78264358',
        workspaceId: '28dcaa9f-5c1c-4f5a-97bf-a4ffa5fc6e6a',
      },
    },
    ASSESSMENT_ELASTIC_ENABLED: false,
  },
  qa: {
    ENV: 'qa',
    NOT_PROD: true,
    NEPTUNE: true,
    ANALYTICS_URL: '/analytics',
    ANALYTICS_V2_URL: '/analytics',
    CHEM_ADMIN_URL: '/chemical-admin',
    CHEMICALS_URL: '/chemicals',
    BSAS_URL: '/bsas/api',
    CLI_URL: '/cli/api',
    NFPA_URL: '/nfpa/api',
    GRAPH_URL: '/graph/api',
    DRIVE_URL: '/drive/api',
    HELP_URL: '/help',
    HELP_SUBMIT_TICKET_URL:
      'https://support.qa.riskandsafety.com/rss_support?id=rss_help_id&sys_id=84817e251bb5e89007d49608bd4bcb9f',
    HELP_SUBMIT_TICKET_URL_EXTERNAL:
      'https://support.qa.riskandsafety.com/rss_support?id=rss_help&sys_id=2d38e9a51b8b1c106a9399f4bd4bcb52',
    LIBRARY_URL: '/library',
    LD_CLIENT_ID: '65725f7f5a57c71063856450',
    MAQ_URL: '/maq',
    PROFILE_URL: '/profile',
    PRINTABLE_URL: '/printable/api',
    BRANDING_URL: '/branding/api',
    BRANDING_GRAPH_URL: '/branding/graphql',
    RELATIONSHIP_GRAPH_URL: '/relationship-v2/graphql',
    RSS_WC_URL: '/web-components',
    TRAINING_API: '/learning',
    COGNITO_AUTH: {
      region: 'us-west-2',
      userPoolId: 'us-west-2_bIillxdK1',
      userPoolWebClientId: 'usu33q80fg4o0mnsrgkli5nie',
      authenticationFlowType: 'USER_SRP_AUTH',
      cookieStorage: {
        domain: document.domain,
        path: '/',
        expires: null,
        secure: true,
      },
      oauth: {
        domain: 'auth.qa.riskandsafety.com',
        scope: ['openid', 'aws.cognito.signin.user.admin'],
        redirectSignIn: `${document.location.protocol}//${document.location.host}`,
        redirectSignOut: `${document.location.protocol}//${document.location.host}/public/signout`,
        responseType: 'code',
      },
    },
    COGNITO_INVITATION_AUTH: {
      region: 'us-west-2',
      userPoolId: 'us-west-2_qaTNgaNEL',
      userPoolWebClientId: '1vsgccf3cnovpn3splkgvhe2ke',
      authenticationFlowType: 'USER_SRP_AUTH',
      storage: window.sessionStorage,
      oauth: {
        domain: 'invite-qa.auth.us-west-2.amazoncognito.com',
        scope: ['openid'],
        redirectSignIn: `${document.location.protocol}//${document.location.host}/public/invitation`,
        redirectSignOut: `${document.location.protocol}//${document.location.host}/`,
        responseType: 'code',
      },
    },
    MOODLE_CLIENT_ID: '4uub8bfd1nu84db7i0nfq76tfp',
    SPOOF_USER_KEY: 'RSS:SPOOF:USER',
    SERVICE_NOW_AUTH_URL:
      'https://ucermtest.service-now.com/login_with_sso.do?glide_sso_id=9118b02a1bfc6c10674286ae6e4bcb55',
    SELECTED_IDP_KEY: 'RSS:SELECTED:IDP',
    ASSESSMENT_ELASTIC_ENABLED: false,
  },
  prod: {
    ENV: 'prod',
    NOT_PROD: false,
    NEPTUNE: true,
    ANALYTICS_URL: '/analytics',
    ANALYTICS_V2_URL: '/analytics',
    CHEM_ADMIN_URL: '/chemical-admin',
    CHEMICALS_URL: '/chemicals',
    BSAS_URL: '/bsas/api',
    CLI_URL: '/cli/api',
    NFPA_URL: '/nfpa/api',
    GRAPH_URL: '/graph/api',
    DRIVE_URL: '/drive/api',
    HELP_URL: '/help',
    HELP_SUBMIT_TICKET_URL:
      'https://support.riskandsafety.com/rss_support?id=rss_help_id&sys_id=84817e251bb5e89007d49608bd4bcb9f',
    HELP_SUBMIT_TICKET_URL_EXTERNAL:
      'https://support.riskandsafety.com/rss_support?id=rss_help&sys_id=2d38e9a51b8b1c106a9399f4bd4bcb52',
    LIBRARY_URL: '/library',
    LD_CLIENT_ID: '645435c3a3e99a12481ad140',
    MAQ_URL: '/maq',
    PROFILE_URL: '/profile',
    PRINTABLE_URL: '/printable/api',
    BRANDING_URL: '/branding/api',
    BRANDING_GRAPH_URL: '/branding/graphql',
    RELATIONSHIP_GRAPH_URL: '/relationship-v2/graphql',
    RSS_WC_URL: '/web-components',
    TRAINING_API: '/learning',
    COGNITO_AUTH: {
      region: 'us-west-2',
      userPoolId: 'us-west-2_s6n7nvnyK',
      userPoolWebClientId: '69v6qi0s1oqqknq8is35r6bl6v',
      authenticationFlowType: 'USER_SRP_AUTH',
      cookieStorage: {
        domain: document.domain,
        path: '/',
        expires: null,
        secure: true,
      },
      oauth: {
        domain: 'auth.app.riskandsafety.com',
        scope: ['openid', 'aws.cognito.signin.user.admin'],
        redirectSignIn: `${document.location.protocol}//${document.location.host}`,
        redirectSignOut: `${document.location.protocol}//${document.location.host}/public/signout`,
        responseType: 'code',
      },
    },
    COGNITO_INVITATION_AUTH: {
      region: 'us-west-2',
      userPoolId: 'us-west-2_yDxNeUPJh',
      userPoolWebClientId: '3m3cv2an4rmf39vb4mf0eohrou',
      authenticationFlowType: 'USER_SRP_AUTH',
      storage: window.sessionStorage,
      oauth: {
        domain: 'rss-prod-invitation.auth.us-west-2.amazoncognito.com',
        scope: ['openid'],
        redirectSignIn: `${document.location.protocol}//${document.location.host}/public/invitation`,
        redirectSignOut: `${document.location.protocol}//${document.location.host}/`,
        responseType: 'code',
      },
    },
    MOODLE_CLIENT_ID: '7q3tvh1l566j1e6idrk1n0rev1',
    SPOOF_USER_KEY: 'RSS:SPOOF:USER',
    SERVICE_NOW_AUTH_URL:
      'https://ucerm.service-now.com/login_with_sso.do?glide_sso_id=749a9e2c1b86641007d49608bd4bcb82',
    SELECTED_IDP_KEY: 'RSS:SELECTED:IDP',
    ASSESSMENT_ELASTIC_ENABLED: false,
  },
  hc: {
    ENV: 'hc',
    NOT_PROD: false,
    NEPTUNE: true,
    ANALYTICS_URL: '/analytics',
    ANALYTICS_V2_URL: '/analytics',
    CHEM_ADMIN_URL: '/chemical-admin',
    CHEMICALS_URL: '/chemicals',
    BSAS_URL: '/bsas/api',
    CLI_URL: '/cli/api',
    NFPA_URL: '/nfpa/api',
    GRAPH_URL: '/graph/api',
    DRIVE_URL: '/drive/api',
    HELP_URL: '/help',
    HELP_SUBMIT_TICKET_URL:
      'https://support.riskandsafety.com/rss_support?id=rss_help_id&sys_id=84817e251bb5e89007d49608bd4bcb9f&hcapp=true',
    HELP_SUBMIT_TICKET_URL_EXTERNAL:
      'https://support.riskandsafety.com/rss_support?id=rss_help&sys_id=2d38e9a51b8b1c106a9399f4bd4bcb52&hcapp=true',
    LIBRARY_URL: '/library',
    LD_CLIENT_ID: '645435c3a3e99a12481ad140',
    PROFILE_URL: '/profile',
    PRINTABLE_URL: '/printable/api',
    BRANDING_URL: '/branding/api',
    RSS_WC_URL: '/web-components',
    TRAINING_API: '/learning',
    COGNITO_AUTH: {
      region: 'us-west-2',
      userPoolId: 'us-west-2_VREa98q6r',
      userPoolWebClientId: '1p05kjf1u79medoepmgs8p6bqb',
      authenticationFlowType: 'USER_SRP_AUTH',
      cookieStorage: {
        domain: document.domain,
        path: '/',
        expires: null,
        secure: true,
      },
      oauth: {
        domain: 'auth.hc.riskandsafety.com',
        scope: ['openid', 'aws.cognito.signin.user.admin'],
        redirectSignIn: `${document.location.protocol}//${document.location.host}`,
        redirectSignOut: `${document.location.protocol}//${document.location.host}/public/signout`,
        responseType: 'code',
      },
    },
    COGNITO_INVITATION_AUTH: {
      region: 'us-west-2',
      userPoolId: 'us-west-2_mVVXQnCTU',
      userPoolWebClientId: '3lcfdji5he9v5c4elt02jgiadn',
      authenticationFlowType: 'USER_SRP_AUTH',
      storage: window.sessionStorage,
      oauth: {
        domain: 'invite-hc.auth.us-west-2.amazoncognito.com',
        scope: ['openid'],
        redirectSignIn: `${document.location.protocol}//${document.location.host}/public/invitation`,
        redirectSignOut: `${document.location.protocol}//${document.location.host}/`,
        responseType: 'code',
      },
    },
    MOODLE_CLIENT_ID: '',
    SPOOF_USER_KEY: 'RSS:SPOOF:USER',
    SERVICE_NOW_AUTH_URL:
      'https://ucerm.service-now.com/login_with_sso.do?glide_sso_id=967570e31b636410393998e1b24bcb62',
    SELECTED_IDP_KEY: 'RSS:SELECTED:IDP',
    ASSESSMENT_ELASTIC_ENABLED: false, // TODO: Need to remove this flag once we rollout elastic changes
  },
};

export const DEBOUNCE_TIME = 400;

const [host1, host2] = window.location.hostname.split('.');

export default config[host1] || config[host2] || config.prod;
